import {
  Button,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  Select,
  Spin,
  Typography,
  List,
  Input,
} from 'antd';
import React, { useState } from 'react';

const { Option } = Select;
const { Text } = Typography;

function FeedbackAdd(props) {
  const {
    isOpen,
    toggle,
    initialValues,
    onSubmit,
    status,
    feedbackTemplates,
  } = props;

  const [form] = Form.useForm();

  const [selectedFeedback, setSelectedFeedback] = useState(null);
  return (
    <Modal
      title="Add Feedback"
      visible={isOpen}
      onCancel={() => toggle()}
      footer={null}
    >
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 14 }}
          onFinish={onSubmit}
          initialValues={initialValues}
          form={form}
        >
          <Form.Item
            label="Feedback Template"
            name="feedbackSkeletonId"
            rules={[{ required: true, message: 'Please input a template!' }]}
          >
            <Select
              onChange={(value) => {
                const template = feedbackTemplates.filter(
                  (feedbackTemplate) => {
                    return feedbackTemplate._id === value;
                  }
                );
                setSelectedFeedback(template[0]);
              }}
            >
              {feedbackTemplates?.map((feedbackTemplate) => {
                return (
                  <Option
                    key={feedbackTemplate._id}
                    value={feedbackTemplate._id}
                  >
                    {feedbackTemplate.name}
                  </Option>
                );
              }) ?? null}
            </Select>
          </Form.Item>
          {selectedFeedback ? (
            <div style={{ marginBottom: '20px' }}>
              <List
                size="large"
                bordered
                dataSource={
                  feedbackTemplates ? selectedFeedback.questions : null
                }
                renderItem={(item) => (
                  <List.Item>
                    <List.Item.Meta
                      title={item.question}
                      description={`Type: ${item.type}`}
                    />
                  </List.Item>
                )}
              />
            </div>
          ) : null}
          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: true, message: 'Please input start date!' }]}
          >
            <DatePicker
              showTime={true}
              showNow={false}
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item
            label="End Date"
            name="endDate"
            rules={[{ required: true, message: 'Please input end date!' }]}
          >
            <DatePicker
              showTime={true}
              showNow={false}
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item label="Title" name="title">
            <Input />
          </Form.Item>
          <Form.Item label="For trainer?" name="forTrainer">
            <Select>
              <Select.Option value={false}>False</Select.Option>
              <Select.Option value={true}>True</Select.Option>
            </Select>
          </Form.Item>
          {status.type === 'ERROR' ? (
            <Text type="danger">{status.message}</Text>
          ) : null}
          {status.type === 'SUCCESS' ? (
            <Text type="success">{status.message}</Text>
          ) : null}
          <Row justify="end" gutter={12}>
            <Col>
              <Button type="primary" htmlType="submit">
                Add
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
}

export default FeedbackAdd;
